module.exports = __webpack_public_path__ + "img/payLogo.516afd7e.png";